import type { ReactNode } from 'react';

import { Button } from '../../../ui/button';
import { tt } from '../i18n';

/**
 * The one place either invitee flow says "wrong account": the top of the
 * card, so it can sit above either the token ladder or the invitation list.
 * With no email to name (a signed-in session carrying no address) it renders
 * the action alone -- naming the fix is the whole reply, where the removed
 * `accept.no_identity` used to spell the impossibility out instead.
 */
export function SwitchAccountBanner(props: {
  email: string | null;
  onSwitch: () => void;
}): ReactNode {
  return (
    <div className="flex flex-col items-center gap-2 text-center">
      {props.email !== null && (
        <p className="text-body-sm text-muted-foreground">
          {tt('accept.switch_account_text', { email: props.email })}
        </p>
      )}
      <Button type="button" variant="outline" size="sm" onClick={props.onSwitch}>
        {tt('accept.switch_account_action')}
      </Button>
    </div>
  );
}
